module.exports = __webpack_public_path__ + "img/search_refund.7582c379.png";